import axios from "axios";
import { context } from "./config";

/**
 * 查詢國家/地區
 * @param {*} page
 * @param {*} size
 * @param {*} searchCriteria
 * @returns
 */
const countryRegion = (page = 0, size = 9999, searchCriteria = {}) => {
  return axios
    .post(
      `${context}/public/api/v1/base/countryRegion/search?page=${page}&size=${size}`,
      searchCriteria
    )
    .then((res) => res.data);
};
/**
 * 查詢參展展區
 * @param {*} page
 * @param {*} size
 * @param {*} searchCriteria
 * @param {*} sort
 * @returns
 */
const boothsArea = (page = 0, size = 9999, searchCriteria = {}, sort) => {
  return axios
    .post(
      `${context}/public/api/v1/base/boothsArea/search?page=${page}&size=${size}`,
      searchCriteria,
      {
        params: {
          sort,
        },
      }
    )
    .then((res) => res.data);
};

/**
 * 查詢展區分類
 * @param {*} page
 * @param {*} size
 * @param {*} searchCriteria
 * @param {*} sort
 * @returns
 */
const boothsAreaCategory = (
  page = 0,
  size = 9999,
  searchCriteria = {},
  sort
) => {
  return axios
    .post(
      `${context}/public/api/v1/base/boothsAreaCategory/search?page=${page}&size=${size}`,
      searchCriteria,
      {
        params: {
          sort,
        },
      }
    )
    .then((res) => res.data);
};

/**
 * 查詢時間表
 * @param {*} activityId 活動id
 * @param {*} status 'PUBLISHED'
 * @param {*} displayInSummary
 * @returns
 */
const getTimeTable = (data = {}) => {
  return axios
    .post(`${context}/public/api/v1/website/timeTable/search`, data)
    .then((res) => res.data);
};

/**
 * 查詢網站其他展區內容
 * @param {*} activityId 活動id
 * @param {*} status 'PUBLISHED'
 * @returns
 */
const getExhibitionArea = (data = {}) => {
  return axios
    .post(`${context}/public/api/v1/website/exhibitionArea/search`, data)
    .then((res) => res.data);
};
/**
 * 查詢報名表
 * @param {*} areaCategoryId
 * @param {*} areaId
 * @param {*} status
 * @returns
 */
const getEnrollmentList = (data = {}, params = {}, status) => {
  return axios
    .post(
      `${context}/public/api/v1/website/enrollment/search`,
      {
        status,
        ...data,
      },
      {
        params: {
          page: params.page,
          size: params.size,
        },
      }
    )
    .then((res) => res.data);
};

/**
 * 獲取當前event
 * @param {*}
 * @returns
 */
const getNowEvent = (data = {}) => {
  return axios
    .get(`${context}/public/api/v1/website/event`, data)
    .then((res) => res.data);
};
/**
 * 查詢展板
 * @param {*} categoryId
 * @param {*} areaId
 * @param {*} enrollmentStatus
 * @returns
 */
const getBoard = (data = {}, page = 0, size = 9999, enrollmentStatus) => {
  return axios
    .post(
      `${context}/public/api/v1/website/board/search`,
      {
        enrollmentStatus,
        ...data,
      },
      {
        params: {
          page,
          size,
        },
      }
    )
    .then((res) => res.data);
};
/**
 * 查詢展板-附件
 * @param {*} boardId 展板id
 * @param {*} result  審批結果
 * @returns
 */
const getBoardFiles = (boardId, result = "ACCEPT") => {
  return axios
    .post(`${context}/public/api/v1/website/boards/attachments`, {
      boardId,
      result,
    })
    .then((res) => res.data);
};
/**
 * 查詢動態表
 * @param {*} activityId 活動id
 * @param {*} status  UN_PUBLISHED"
 * @returns
 */
const getWebsiteTable = (data = {}) => {
  return axios
    .post(`${context}/public/api/v1/website/websiteDynamicTable/search`, data)
    .then((res) => res.data);
};

/**
 * 提交動態表
 * @param {*} code 申請編碼
 * @param {*} captcha 驗證碼
 * @param {*} tableId
 * @param {*} data
 * @returns
 */
const websiteTableSubmit = (code, captcha, tableId, data) => {
  return axios
    .post(`${context}/public/api/v1/website/websiteDynamicTable/submit`, data, {
      params: {
        code,
        captcha,
        tableId,
      },
    })
    .then((res) => res.data);
};

/**
 * 查詢動態表 - 查詢編號
 * @param {*} code 驗證碼
 * @returns
 */
const SearchWebsiteTable = (code) => {
  return axios
    .post(
      `${context}/public/api/v1/website/websiteDynamicTable`,
      {},
      {
        params: {
          code,
        },
      }
    )
    .then((res) => res.data);
};

export default {
  countryRegion,
  boothsArea,
  boothsAreaCategory,
  getTimeTable,
  getExhibitionArea,
  getEnrollmentList,
  getWebsiteTable,
  getNowEvent,
  getBoard,
  getBoardFiles,
  websiteTableSubmit,
  SearchWebsiteTable,
};
